import { render } from "./BadgeInfo.vue?vue&type=template&id=526110be&scoped=true"
import script from "./BadgeInfo.vue?vue&type=script&lang=js"
export * from "./BadgeInfo.vue?vue&type=script&lang=js"

import "./BadgeInfo.vue?vue&type=style&index=0&id=526110be&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526110be"]])

export default __exports__